<h4 class="text-xl font-semibold mt-3 ml-3">{{ title | translate | interpolate:params }}</h4>
@if (subtitle) {
  <p class="mb-1 mt-1 ml-3 mr-3 border-box color-light">{{ subtitle | translate | interpolate:params }}</p>
}
